import React from "react";
import { Site } from "../../types/Emailstypes";

interface SiteCardProps {
  site: Site;
  selected: boolean;
  onClick: () => void;
}

const SiteCard: React.FC<SiteCardProps> = ({ site, selected, onClick }) => (
  <button
    onClick={onClick}
    style={{ "--accent": site.color } as React.CSSProperties}
    className={`group relative w-full text-left rounded-2xl p-4 flex flex-col gap-3 min-h-[120px]
      transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--accent)] focus-visible:ring-offset-2
      ${selected
        ? "border-2 border-[var(--accent)] bg-white shadow-[0_4px_20px_-4px_var(--accent)] scale-[1.02]"
        : "border border-slate-100 bg-white hover:border-[var(--accent)] hover:shadow-[0_4px_16px_-6px_var(--accent)] hover:scale-[1.015] shadow-sm"
      }`}
  >
     {selected && (
      <span
        className="absolute top-2.5 right-2.5 flex items-center justify-center w-5 h-5 rounded-full text-white shadow-sm"
        style={{ backgroundColor: site.color }}
      >
        <svg className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
        </svg>
      </span>
    )}

    {/* Icon */}
    <div
      className="w-10 h-10 rounded-xl flex items-center justify-center text-xl text-white flex-shrink-0
        shadow-[0_2px_8px_-2px_var(--accent)] transition-transform duration-200 group-hover:scale-110"
      style={{ backgroundColor: site.color }}
    >
      {site.icon}
    </div>

     <div className="min-w-0">
      <p className="text-[13px] font-bold text-slate-800 truncate leading-tight">{site.label}</p>
      <p className="mt-0.5 text-[11px] text-slate-400 line-clamp-2 leading-relaxed">{site.description}</p>
    </div>

     {selected && (
      <div
        className="absolute bottom-0 left-4 right-4 h-0.5 rounded-full opacity-50"
        style={{ backgroundColor: site.color }}
      />
    )}
  </button>
);

export default SiteCard;